import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { api, fmtDate, errMsg } from "@/lib/api";
import { LoadError } from "@/admin/LoadError";

const FILTERS = [["", "All"], ["warnings", "Warnings"], ["approaching", "≥80% usage"], ["active", "Active"], ["past_due", "Past due"], ["canceled", "Canceled"], ["suspended", "Suspended"], ["pilot", "Pilot"]];
export const WARN_LABEL: Record<string, string> = {
  website_allowance_exhausted: "Allowance used up", website_allowance_80: "≥80% allowance", field_ceiling_80: "≥80% field ceiling",
  past_due: "Past due", suspended: "Suspended", not_entitled: "Not entitled",
};

export default function AdminCompanies() {
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("");
  const [rows, setRows] = useState<any[] | null>(null);
  const [err, setErr] = useState("");
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => {
      setErr("");
      api.get("/admin/orgs", { params: { q: q || undefined, filter: filter || undefined } }).then((r) => setRows(r.data.orgs)).catch((e) => { setRows(null); setErr(errMsg(e)); });
    }, 250);
    return () => clearTimeout(t);
  }, [q, filter, tick]);
  return (
    <div className="space-y-4" data-testid="admin-companies">
      <Input className="h-12 text-base" placeholder="Search company, slug or owner email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-company-search" />
      <div className="flex gap-2 overflow-x-auto pb-1">
        {FILTERS.map(([v, l]) => (
          <button key={v || "all"} onClick={() => setFilter(v)} data-testid={`admin-filter-${v || "all"}`}
            className={`h-9 px-3 rounded-full text-xs border whitespace-nowrap ${filter === v ? "bg-foreground text-background" : "bg-card"}`}>{l}</button>
        ))}
      </div>
      {err ? <LoadError what="companies" detail={err} onRetry={() => setTick((n) => n + 1)} testid="admin-companies-error" /> : rows === null ? <p className="text-muted-foreground text-sm">Loading…</p> : rows.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="admin-companies-empty">No companies match.</p> : (
        <ul className="space-y-2" data-testid="admin-company-list">
          {rows.map((o) => (
            <li key={o.id}>
              <Link to={`/app/admin/companies/${o.id}`} className="block bg-card border rounded-xl p-4 hover:border-primary" data-testid={`admin-company-${o.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className="font-semibold truncate">{o.name}</p>
                    <p className="text-xs text-muted-foreground truncate">{o.owner?.name ? `${o.owner.name} · ` : ""}{o.owner?.email} · joined {fmtDate(o.created_at)}</p>
                  </div>
                  <span className="text-xs rounded-full px-2 py-0.5 bg-secondary">{o.billing.status}{o.billing.status !== "none" && !o.billing.livemode ? " (test)" : ""}{o.pilot_override ? " · pilot" : ""}</span>
                </div>
                <div className="mt-2 grid grid-cols-2 sm:grid-cols-5 gap-2 text-xs">
                  <span>Website <b className="font-mono">{o.allowance.website_used}/{o.allowance.available}</b></span>
                  <span>Field <b className="font-mono">{o.allowance.field_used}</b></span>
                  <span>Leads <b>{o.website_leads}</b> · FQ <b>{o.field_quotes}</b></span>
                  <span>Services <b>{o.published_services}</b></span>
                  <span>Active {o.last_activity_at ? fmtDate(o.last_activity_at) : "—"}</span>
                </div>
                {o.warnings.length > 0 && <div className="mt-2 flex flex-wrap gap-1">{o.warnings.map((w: string) => <span key={w} className="text-[10px] rounded-full px-2 py-0.5 bg-amber-100 text-amber-900">{WARN_LABEL[w] || w}</span>)}</div>}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
